export default __webpack_public_path__ + "static/media/nardi.122af881.svg";